// extracted by mini-css-extract-plugin
module.exports = {"ldsEllipsis":"Loader_ldsEllipsis__i0Ulx","lds-ellipsis1":"Loader_lds-ellipsis1__iFo50","lds-ellipsis2":"Loader_lds-ellipsis2__6IiPi","lds-ellipsis3":"Loader_lds-ellipsis3__w86T2"};